import React from 'react';
import { Link } from 'react-router-dom';

// Informativa privacy per utenti del portale, soci, tesserati, corsisti (e genitori), partecipanti a
// tornei e chi compila i moduli pubblici. I collaboratori hanno in più la loro (InformativaCollaboratori).
// Cambiare VERSIONE_PRIVACY quando il testo cambia in modo sostanziale e allinearla a
// backend/src/modules/auth/privacy-utenti.ts → al login viene richiesta di nuovo la presa visione.
export const VERSIONE_PRIVACY = '2026-10-15';

const EMAIL = 'amministrazione@b-cheers.it';

export function TestoPrivacy() {
  const mail = <a href={`mailto:${EMAIL}`} style={s.link}>{EMAIL}</a>;
  return (
    <>
      <section style={s.section}>
        <h2 style={s.h2}>1. Chi tratta i tuoi dati</h2>
        <p style={s.p}>
          Il titolare del trattamento è <strong>B-CHEERS BEACH VOLLEY TEAM ASD</strong>, Via Macon 30, 23900 Lecco (LC),
          C.F. 92083420130, P.IVA 04176230136, email {mail}.<br/>
          L'associazione non è tenuta a nominare un Responsabile della protezione dei dati (DPO): per qualsiasi domanda scrivi all'indirizzo sopra.
        </p>
        <p style={s.p}>
          Questa informativa riguarda soci, tesserati, corsisti e i loro genitori, partecipanti a tornei ed eventi, chi prenota i campi o acquista
          dall'associazione, chi compila i nostri moduli online e chi usa il portale. I collaboratori sportivi ricevono in più un'informativa dedicata
          al rapporto di collaborazione.
        </p>
      </section>

      <section style={s.section}>
        <h2 style={s.h2}>2. Quali dati trattiamo</h2>
        <ul style={s.ul}>
          <li><strong>Anagrafica</strong>: nome, cognome, data e luogo di nascita, sesso, codice fiscale, indirizzo.</li>
          <li><strong>Contatti</strong>: email e telefono.</li>
          <li><strong>Tesseramento</strong>: numero e tipo di tessera presso enti e federazioni (es. ASI, FIPAV), date di validità, quote associative.</li>
          <li><strong>Attività sportiva</strong>: iscrizioni a corsi, gruppi e orari, presenze, iscrizioni a tornei ed eventi, coppie e risultati.</li>
          <li><strong>Dati economici</strong>: pagamenti, ricevute, ordini, prenotazioni dei campi (non conserviamo i dati delle carte di pagamento).</li>
          <li><strong>Moduli online</strong>: le risposte che inserisci, compresi eventuali allegati, fotografie scattate o caricate e la firma apposta sul modulo.</li>
          <li><strong>Richieste di assistenza</strong> inviate tramite il portale.</li>
          <li><strong>Dati di accesso</strong>: email, password (conservata solo in forma cifrata), registro degli accessi e delle operazioni con indirizzo IP.</li>
          <li><strong>Immagini</strong> (foto e video durante attività ed eventi): solo se hai dato il consenso specifico, vedi punto 4.</li>
        </ul>
        <p style={s.p}>
          Non chiediamo dati relativi alla salute né altre categorie particolari di dati (art. 9 GDPR). Ti chiediamo di non inserirli nei campi di testo
          libero o negli allegati se non sono espressamente richiesti.
        </p>
      </section>

      <section style={s.section}>
        <h2 style={s.h2}>3. Da dove arrivano i dati</h2>
        <p style={s.p}>Di regola ce li fornisci tu (o il genitore, per i minori), di persona, tramite i moduli online o il portale. In alcuni casi li riceviamo da:</p>
        <ul style={s.ul}>
          <li>enti di promozione sportiva e federazioni a cui l'associazione è affiliata (es. ASI, FIPAV), per lo stato del tesseramento;</li>
          <li>piattaforme di iscrizione a tornei e attività usate dall'associazione (es. Dink), quando ti iscrivi tramite esse;</li>
          <li>il tuo compagno o la tua compagna di squadra, quando vi iscrive in coppia a un torneo.</li>
        </ul>
      </section>

      <section style={s.section}>
        <h2 style={s.h2}>4. Perché li trattiamo e su quale base giuridica</h2>
        <ul style={s.ul}>
          <li><strong>Gestire il rapporto con te</strong>: adesione all'associazione, tesseramento, corsi, tornei, prenotazioni, acquisti, account sul portale, comunicazioni organizzative (email, telefono, messaggi). Base giuridica: esecuzione del contratto o di misure richieste da te (art. 6, par. 1, lett. b GDPR).</li>
          <li><strong>Adempimenti di legge</strong>: contabilità, fisco, ricevute, libro soci, tesseramento con copertura assicurativa, comunicazioni al Registro nazionale delle attività sportive dilettantistiche. Base giuridica: obbligo di legge (art. 6, par. 1, lett. c GDPR).</li>
          <li><strong>Sicurezza e tutela</strong>: registro degli accessi, backup, prevenzione di abusi, difesa dei diritti dell'associazione. Base giuridica: legittimo interesse del titolare (art. 6, par. 1, lett. f GDPR).</li>
          <li><strong>Foto e video per sito e social dell'associazione</strong>: solo con il tuo consenso (art. 6, par. 1, lett. a GDPR), facoltativo e revocabile in ogni momento senza conseguenze sulla partecipazione alle attività.</li>
        </ul>
        <p style={s.p}>
          Fornire i dati delle prime due voci è necessario: senza di essi non possiamo iscriverti né erogare i servizi. Per queste finalità non serve il tuo consenso.
          Non usiamo i tuoi dati per pubblicità di terzi e non li vendiamo.
        </p>
      </section>

      <section style={s.section}>
        <h2 style={s.h2}>5. Minori</h2>
        <p style={s.p}>
          Per i minori di 18 anni l'iscrizione e i moduli sono compilati da chi esercita la responsabilità genitoriale, che riceve questa informativa e decide sugli
          eventuali consensi (es. immagini). L'account sul portale può essere creato in autonomia solo dai maggiori di 14 anni (art. 2-quinquies D.Lgs. 196/2003).
        </p>
      </section>

      <section style={s.section}>
        <h2 style={s.h2}>6. Chi può vedere i dati</h2>
        <p style={s.p}>
          All'interno dell'associazione, solo il personale e i collaboratori autorizzati, e ciascuno solo per i dati che servono al suo compito
          (ad esempio un allenatore vede i propri gruppi, non i pagamenti). I dati possono essere comunicati a:
        </p>
        <ul style={s.ul}>
          <li>enti di promozione sportiva e federazioni (es. ASI, FIPAV) per tesseramenti, assicurazione e iscrizione a gare e tornei;</li>
          <li>pubbliche amministrazioni (Agenzia delle Entrate, Dipartimento per lo Sport) quando lo prevede la legge;</li>
          <li>commercialista e consulenti dell'associazione;</li>
          <li>banche e servizi di pagamento (es. Satispay) per gli incassi;</li>
          <li>fornitori dei servizi informatici: hosting del portale (Oracle, server situati in Italia), posta elettronica e sito web (SiteGround, server nell'Unione Europea), assistenza tecnica e sviluppo del software.</li>
        </ul>
        <p style={s.p}>
          I fornitori che trattano dati per conto dell'associazione agiscono come responsabili del trattamento (art. 28 GDPR) secondo i rispettivi accordi; gli enti sportivi,
          le pubbliche amministrazioni, le banche e i servizi di pagamento trattano i dati come titolari autonomi. I tuoi dati non vengono diffusi: nome e cognome
          possono comparire solo in elenchi, tabelloni e classifiche di tornei ed eventi a cui partecipi.
        </p>
      </section>

      <section style={s.section}>
        <h2 style={s.h2}>7. Dove sono conservati</h2>
        <p style={s.p}>
          Il portale e il database si trovano su server in Italia. Alcuni fornitori appartengono a gruppi con sede fuori dall'Unione Europea: se dovesse avvenire un
          trasferimento di dati verso paesi terzi, questo è coperto da una decisione di adeguatezza della Commissione europea (es. EU-US Data Privacy Framework) o da
          clausole contrattuali standard (art. 45–46 GDPR).
        </p>
      </section>

      <section style={s.section}>
        <h2 style={s.h2}>8. Per quanto tempo</h2>
        <ul style={s.ul}>
          <li>Documenti contabili e fiscali (ricevute, pagamenti): 10 anni, come previsto dalla legge.</li>
          <li>Soci, tesserati, corsisti, partecipanti: per la durata del rapporto e fino a 5 anni dalla sua fine, salvo i dati da conservare più a lungo per legge.</li>
          <li>Risposte ai moduli online: per il tempo necessario allo scopo del modulo; se il modulo è un'iscrizione, seguono i tempi dell'iscrizione.</li>
          <li>Account del portale: finché è attivo; su tua richiesta lo cancelliamo, salvo i dati da conservare per legge.</li>
          <li>Registro degli accessi e delle operazioni: 12 mesi (le registrazioni relative a incassi seguono i tempi dei dati contabili).</li>
          <li>Copie di sicurezza (backup): circa 30 giorni, poi sovrascritte.</li>
          <li>Immagini: fino alla revoca del consenso.</li>
        </ul>
      </section>

      <section style={s.section}>
        <h2 style={s.h2}>9. Come proteggiamo i dati</h2>
        <p style={s.p}>
          Collegamento cifrato (HTTPS), password conservate solo in forma cifrata, accessi per ruolo con i soli permessi necessari, registro delle operazioni sensibili,
          backup giornalieri, server in Italia. Le pagine del portale non caricano risorse da servizi esterni (caratteri, statistiche, pubblicità): il tuo browser
          comunica solo con il nostro server.
        </p>
      </section>

      <section style={s.section}>
        <h2 style={s.h2}>10. Cookie e memoria del browser</h2>
        <p style={s.p}>
          Il portale usa solo strumenti <strong>tecnici</strong>, necessari al suo funzionamento: nella memoria del browser (localStorage) salva il codice di accesso
          della sessione e alcune preferenze di visualizzazione (tema chiaro/scuro, pagine e viste scelte). Non usiamo cookie di profilazione, di statistica o di terze
          parti: per questo, secondo le Linee guida del Garante del 10 giugno 2021, non serve un banner di consenso. Puoi cancellare questi dati in ogni momento dalle
          impostazioni del browser o uscendo dal portale.
        </p>
        <p style={s.p}>
          I collegamenti a servizi esterni (es. pagamento Satispay, WhatsApp, siti delle federazioni) portano su siti di terzi, con le loro informative.
        </p>
      </section>

      <section style={s.section}>
        <h2 style={s.h2}>11. I tuoi diritti</h2>
        <p style={s.p}>
          Puoi chiedere in ogni momento di accedere ai tuoi dati, correggerli, cancellarli (salvo quelli da conservare per legge), limitarne il trattamento, riceverli
          in un formato leggibile (portabilità) e opporti al trattamento basato sul legittimo interesse (artt. 15–21 GDPR). Puoi revocare il consenso alle immagini
          in qualsiasi momento, senza effetti sui trattamenti precedenti. Scrivi a {mail}: rispondiamo entro 30 giorni.
        </p>
        <p style={s.p}>
          Hai inoltre diritto di proporre reclamo al Garante per la protezione dei dati personali
          (<a href="https://www.garanteprivacy.it" target="_blank" rel="noreferrer" style={s.link}>www.garanteprivacy.it</a>).
          Non prendiamo decisioni basate unicamente su trattamenti automatizzati.
        </p>
      </section>

      <section style={{ ...s.section, borderBottom: 'none' }}>
        <h2 style={s.h2}>12. Aggiornamenti</h2>
        <p style={s.p}>
          Se questa informativa cambia in modo sostanziale, te lo segnaliamo al primo accesso al portale. Versione in vigore: {VERSIONE_PRIVACY.split('-').reverse().join('/')}.
        </p>
      </section>
    </>
  );
}

export default function Privacy() {
  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.logo}>B-CHEERS ASD</div>
        <h1 style={s.title}>Informativa sul trattamento dei dati personali</h1>
        <p style={s.sub}>ai sensi degli artt. 13 e 14 del Regolamento UE 2016/679 (GDPR) e del D.Lgs. 196/2003</p>
        <TestoPrivacy/>
        <div style={s.footer}>
          <Link to="/login" style={s.backLink}>← Torna al login</Link>
        </div>
      </div>
    </div>
  );
}

export const s = {
  page:     { minHeight: '100vh', background: 'var(--bg)', padding: '40px 16px', display: 'flex', justifyContent: 'center' },
  card:     { background: 'var(--bg)', border: '1px solid var(--border)', borderRadius: '16px', padding: 'clamp(24px, 5vw, 48px)', width: '100%', maxWidth: '860px', height: 'fit-content', boxSizing: 'border-box' },
  logo:     { fontFamily: "'Barlow Condensed'", fontSize: '22px', fontWeight: '800', color: '#F4600C', letterSpacing: '3px', marginBottom: '24px' },
  title:    { fontSize: '22px', fontWeight: '800', color: 'var(--text)', margin: '0 0 8px 0', lineHeight: '1.3' },
  sub:      { fontSize: '13px', color: 'var(--text-dim)', margin: '0 0 36px 0', fontStyle: 'italic' },
  section:  { marginBottom: '28px', borderBottom: '1px solid var(--border)', paddingBottom: '20px' },
  h2:       { fontSize: '15px', fontWeight: '800', color: '#F4600C', letterSpacing: '1px', margin: '0 0 12px 0', textTransform: 'uppercase' },
  p:        { fontSize: '14px', color: 'var(--text)', lineHeight: '1.7', margin: '0 0 10px 0' },
  ul:       { fontSize: '14px', color: 'var(--text)', lineHeight: '1.7', margin: '0 0 10px 0', paddingLeft: '20px' },
  link:     { color: '#F4600C', textDecoration: 'none', fontWeight: '600' },
  footer:   { marginTop: '24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px' },
  backLink: { color: '#F4600C', textDecoration: 'none', fontWeight: '700', fontSize: '14px' },
};
